module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fig",
    attrs: {
      "id": "link7"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Some quiltmakers like to follow patterns, some like to completely design their own quilts, and some are in between—they like using patterns but always want to change things up a bit. No matter where you are in this quiltmaking spectrum, you can make a collage quilt.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "toc2"
    }
  }, [_vm._v("Projects")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("For the eight projects in this book, you can use fabric and colors similar to those pictured or you can change up the colors and fabrics any way you like. Full-size patterns for the projects are included on the pattern pullout at the back of the book—they are ready to use to make the pictured quilts. Depending on the size quilt you are making, you may need to enlarge or reduce the patterns.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "toc3"
    }
  }, [_vm._v("Creating a Design")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("If you want to create your own design and pattern, some of you may have no trouble drawing a design the exact size you need. If you don’t want to draw your own large pattern or are creating a particularly complex design, I have some simple solutions for you! You can make your own full-size pattern using a copy service that does large-scale enlargements, or you can use graph paper and Tru-Grid material to scale the image to the needed size.")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11_2.jpg"
    }
  }), _vm._v(" "), _c('i', [_vm._v("If you want to completely design your own quilt, use the information in this Basics chapter and refer to the "), _c('span', {
    attrs: {
      "href": "#/26_chapter20#link43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yardage Chart")]), _vm._v(" to see how much fabric you’ll need.")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "toc4"
    }
  }, [_vm._v("Making Your Own Pattern")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Either draw your own design or find a design you can print. If you search online for images, try using search terms such as "), _c('i', [_vm._v("vector")]), _vm._v(", "), _c('i', [_vm._v("outline")]), _vm._v(", or "), _c('i', [_vm._v("printable")]), _vm._v(" to find simple images that can easily be traced and cut out, and that will translate well into the collage medium. For example, images with a lot of depth and shadows may be difficult to replicate in a collage.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('i', [_vm._v("Important: If you are using a design that is not an original design that you made yourself, make sure that the design is copyright-free or get permission from the creator or owner of the design.")])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("ENLARGING USING A COPY MACHINE")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('span', {
    staticClass: "col"
  }, [_c('b', [_vm._v("Materials needed:")])]), _vm._v(" copy machine capable of enlarging images (copy shops often have machines capable of large-format printing)")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("After you have the drawing or printed design, use a copy machine to enlarge the image to the size you need.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("ENLARGING USING A GRID")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('span', {
    staticClass: "col"
  }, [_c('b', [_vm._v("Materials needed:")])]), _vm._v(" graph paper, Tru-Grid (see "), _c('span', {
    attrs: {
      "href": "#/27_chapter21#link45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resources")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "txtt"
  }, [_c('span', {
    staticClass: "col"
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Draw or trace the design onto graph paper. Be sure to have 1 square on the paper represent 1 square inch on your actual quilt. For example, for a quilt that is 50˝ × 60˝, the design on the graph paper should be 50 squares × 60 squares.")]), _vm._v(" "), _c('p', {
    staticClass: "txtt"
  }, [_c('span', {
    staticClass: "col"
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Enlarge the design by drawing the part of the design in each graph paper square in the corresponding square on the Tru-Grid.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "toc5"
    }
  }, [_vm._v("Choosing a Color Palette")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Who doesn’t love picking out colors? A color palette may be predetermined by a room’s color scheme or the preference of the lucky person receiving the quilt you are making. If not, here are a few ideas to keep in mind.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg13_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Consider the color wheel when choosing the predominant colors for a quilt. I use C&T Publishing’s Ultimate 3-in-1 Color Tool to help me choose a palette, and I take it with me when buying fabric to ensure I choose the correct shades. For each of the 24 pure colors, the tool provides tints, shades, and tones, as well as 5 color plans.")]), _vm._v(" "), _c('p', {
    staticClass: "h2a",
    attrs: {
      "id": "link4"
    }
  }, [_vm._v("Monochromatic")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg13_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg13_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('i', [_vm._v("Monochromatic")]), _vm._v(" means “one color.” In this plan, the palette is based on one pure color; variety comes from choosing different tints, shades, and tones of that one color. Monochromatic color schemes are quiet and calm.")]), _vm._v(" "), _c('p', {
    staticClass: "h2a",
    attrs: {
      "id": "link6"
    }
  }, [_vm._v("Analogous")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg13_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg13_5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Choose one color and then select a few colors that are next to it on the color wheel. Analogous color schemes are easy to work with and the colors always work well together.")]), _vm._v(" "), _c('p', {
    staticClass: "h2a",
    attrs: {
      "id": "link3"
    }
  }, [_vm._v("Complementary")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg14_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Complementary colors are colors opposite each other on the color wheel and are the boldest of color combinations. Placing complementary colors next to each other achieves the greatest level of contrast.")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11_2.jpg"
    }
  }), _vm._v(" "), _c('i', [_vm._v("For a really dynamic palette, add one or two neutrals (white, black, gray, brown).")])]), _vm._v(" "), _c('p', {
    staticClass: "h2a",
    attrs: {
      "id": "link5"
    }
  }, [_vm._v("Split-Complementary")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg14_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg14_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("This plan combines the previous two color plans. Select complementary colors and then choose one set of analogous colors to use as well. This color combination provides much of the contrast of a complementary color scheme but is toned down a bit.")]), _vm._v(" "), _c('p', {
    staticClass: "h2a"
  }, [_vm._v("Triadic")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg14_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("A triadic color plan uses three colors that are evenly spaced from one another on the color wheel. It provides contrast as well as balance and harmony.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Color Palette Ideas")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Different color palette choices can completely change the look of a quilt. I usually choose the color(s) of my collage first. I typically prefer a "), _c('a', {
    attrs: {
      "href": "#/09_chapter3#link4"
    }
  }, [_vm._v("monochromatic collaged image")]), _vm._v(". After I’ve selected my collage color, I decide on the other colors needed—colors for the background, binding, and backing.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("When choosing a background fabric (whether it is a solid piece of fabric behind the collage or a pieced background), decide whether you want the collage to stand out or to blend in with the background. If you want the collage to stand out, think about selecting a "), _c('a', {
    attrs: {
      "href": "#/09_chapter3#link3"
    }
  }, [_vm._v("complementary color")]), _vm._v(" or a neutral. If you’d like the collage to blend in, you may want to choose an "), _c('a', {
    attrs: {
      "href": "#/09_chapter3#link6"
    }
  }, [_vm._v("analogous color")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("After I’ve selected the collage and background colors (and usually after I’ve finished my quilt top), I choose the binding. When choosing the binding fabric, look at the quilt top and decide whether you want the binding to stand out, to blend in with and complement the quilt top, or to provide a strong frame for the design while not standing out too much.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg15_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("I chose a "), _c('a', {
    attrs: {
      "href": "#/09_chapter3#link5"
    }
  }, [_vm._v("split-complementary palette")]), _vm._v(" for this quilt. The jade binding stands out but balances the bold and contrasting purple in the elephant. (See "), _c('i', [_c('span', {
    attrs: {
      "href": "#/19_chapter13#link36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blocks for Elephants")])]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg16_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("For this quilt, I chose a "), _c('a', {
    attrs: {
      "href": "#/09_chapter3#link3"
    }
  }, [_vm._v("complementary palette")]), _vm._v(" to use with the bold black and white neutrals. Since the border was so bold, I didn’t want the binding to take away from that—I chose a print with a white background that had the same blue and orange shades as the center of the quilt. This brought those colors to the edge, allowing for a more balanced design. (See "), _c('i', [_c('span', {
    attrs: {
      "href": "#/17_chapter11#link34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tamed Fox")])]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg16_1a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("I wanted a very natural, organic look for this quilt. So I went with a "), _c('a', {
    attrs: {
      "href": "#/09_chapter3#link4"
    }
  }, [_vm._v("monochromatic palette")]), _vm._v(" with the neutral background. The brown binding closes in the quilt top, providing a strong frame for the design while not detracting from the main image. (See "), _c('span', {
    attrs: {
      "href": "#/18_chapter12#link35",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Windy Popla")]), _vm._v("r")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("I choose the backing last since it is usually the least visible element of the quilt. Just because it is on the back, that doesn’t mean it does not matter. The backing can make a strong statement about the rest of the quilt. Choosing a backing that really pops might be a great option if you’ve chosen a simple palette for the quilt top and binding—for this effect, choose a color on the opposite side of the wheel. If you’d like the backing to blend in and complement the rest of the quilt, choose a color already used in the quilt, a neutral, or an analogous color.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("There are no hard-and-fast rules for color selection. If you’d like to break some of these color theory guidelines, go for it! This is your quilt—choose what looks good to your eye!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55d8e20c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/09_chapter3.vue
// module id = 78
// module chunks = 0